// src/components/kuestion/solo/SoloBanks.jsx
// "Your material": banks and templates at a glance, with the existing
// Manage Data and Exam Templates screens one click away.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSoloData } from './soloData';
import { Loading, RuleHead } from '../shared/Bits';
import { fmtDate } from '../shared/format';
import { kq } from '../../../config/routes';

export default function SoloBanks() {
  const navigate = useNavigate();
  const { files, templates } = useSoloData();
  const banks = (files || []).filter((f) => f.file_type === 'json' || f.bank_id != null);

  return (
    <div className="kqc-page kqc-page--narrow" style={{ maxWidth: 900 }}>
      <div className="kqc-kicker" style={{ marginBottom: 10 }}>Your material</div>
      <h1 className="kqc-h1" style={{ marginBottom: 12 }}>Banks &amp; templates</h1>
      <p className="kqc-lede" style={{ marginBottom: 26 }}>Your questions, your papers. Nothing here is shared with anyone &mdash; there is no organisation attached to this account.</p>
      <div className="kqc-row" style={{ marginBottom: 26 }}>
        <button type="button" className="btn btn-primary" onClick={() => navigate(kq('banks/manage'))}>Upload a bank</button>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(kq('templates/build'))}>Build a template</button>
        <button type="button" className="btn btn-secondary" onClick={() => navigate(kq('templates'))}>Pass marks</button>
      </div>

      {files === null ? <Loading label="Loading banks" /> : banks.length === 0 ? (
        <div className="kqc-empty">No banks yet. Upload a JSON question file, or write questions by hand in Manage data.</div>
      ) : (
        <div className="table-wrap">
          <table className="table" style={{ minWidth: 560 }}>
            <thead><tr><th>Bank</th><th>Questions</th><th>Status</th><th>Added</th><th /></tr></thead>
            <tbody>
              {banks.map((f) => (
                <tr key={f.id}>
                  <td><strong className="kqc-mono">{f.exam_code || f.original_name}</strong>{f.module ? <span className="kqc-small kqc-muted"> · {f.module}</span> : null}</td>
                  <td>{f.question_count ?? '—'}</td>
                  <td>{f.is_valid ? <span className="tag tag-ink">Valid</span> : <span className="tag tag-outline">Invalid</span>}</td>
                  <td>{fmtDate(f.upload_date)}</td>
                  <td className="is-right"><button type="button" className="btn btn-ghost btn-sm" style={{ minHeight: 0, display: 'inline-flex' }} onClick={() => navigate(kq('banks/manage'))}>Open</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div style={{ margin: 'clamp(24px,3vw,34px) 0 12px' }}><RuleHead title="Templates" /></div>
      {templates === null ? <Loading label="Loading templates" /> : templates.length === 0 ? (
        <div className="kqc-empty">No templates yet. A template is the paper: which banks, how many questions, how long, how it scores.</div>
      ) : (
        <div className="kqc-list" style={{ maxWidth: 620 }}>
          {templates.map((t) => (
            <div key={t.id} className="kqc-list__row is-static" style={{ padding: '13px 0', alignItems: 'baseline' }}>
              <strong className="kqc-mono" style={{ flex: 1, fontSize: 15, minWidth: 160 }}>{t.template_name || t.exam_name}</strong>
              <span className="kqc-small kqc-muted">{t.total_questions} questions &middot; {t.time_limit} {t.time_unit === 'hours' ? 'h' : 'min'} &middot; {t.pass_percentage != null ? `pass ${t.pass_percentage}%` : 'no pass mark'}</span>
              <button type="button" className="btn btn-ghost btn-sm" style={{ minHeight: 0 }} onClick={() => navigate(kq('templates'))}>Edit</button>
              <button type="button" className="btn btn-ghost btn-sm" style={{ minHeight: 0 }} onClick={() => navigate(kq(`exam/${t.id}`))}>Sit it &rarr;</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
